import {
  PurchaseHeader,
  PurchaseItem,
} from "app/modules/transactions/purchase/models/purchase.model";
import { Supplier } from "app/modules/masters/supplier/model/supplier.model";

export type SupplierError = string | { message: string; field?: string } | null;

export interface SupplierState {
  suppliers: Supplier[];
  loading: boolean;
  error: string | null;
  createSuccess: boolean;
  createError: SupplierError;
  updateSuccess?: boolean;
  updateError?: SupplierError;
}

export const initialSupplierState: SupplierState = {
  suppliers: [],
  loading: false,
  error: null,
  createSuccess: false,
  createError: null,
  updateSuccess: false,
  updateError: null,
};

export interface PaginatedSuppliers {
  supplier: Supplier[];
  total: number;
  page: number;
  limit: number;
}